var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMenuReminders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21513_1408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 12C10.3334 13.2887 9.28875 14.3333 8.00008 14.3333C6.71141 14.3333 5.66675 13.2887 5.66675 12",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 1.33301L14.6666 14.6663",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.8211C14 10.5083 13.8757 10.2084 13.6546 9.98719L13.2525 9.58506C12.8774 9.20999 12.6667 8.70126 12.6667 8.17086V6.33366C12.6667 3.75633 10.5773 1.66699 8 1.66699C6.96647 1.66699 6.01137 2.00299 5.23805 2.57171M3.17925 12.0003C2.52797 12.0003 2 11.4723 2 10.8211C2 10.5083 2.12424 10.2084 2.34539 9.98719L2.74755 9.58506C3.12262 9.20999 3.33333 8.70126 3.33333 8.17086V6.33366C3.33333 5.47259 3.56654 4.66599 3.97325 3.97357L12 12.0003H3.17925Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21513_1408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuReminders);
export default __webpack_public_path__ + "static/media/group_menu_reminders.b67a70487a359e4b9b7631192aabc052.svg";
export { ForwardRef as ReactComponent };